import React, { useEffect, useState } from 'react'
import { BooleanInput, TextInput, useGetList, required, SimpleForm } from 'react-admin'
import { useFormContext } from 'react-hook-form'
import PermissionTable from '../../components/domains/roles-permission/PermissionTable'
import { CreateBase } from '../../components/base'
import { Grid } from '@mui/material'
import { COMMON_FIELDS, ROLES_FIELDS } from '../../providers/localization/constant'
import { RolePermission } from './type'
import isEmpty from 'lodash/isEmpty'
import { registerPermissions } from '../../utils/user'
import { FormBottomToolbarWithPermission } from '../../components/form'
import { AllPermissionBooleanInput } from '../../components/domains/roles-permission'

const RESOURCE_PREFIX = 'resources.roles.create'

const RolesPermissionsCreateFormBody = (): JSX.Element => {
  const { data: permissionKeys } = useGetList('permissions', {
    sort: { field: 'key', order: 'ASC' },
  })
  const { register, getValues } = useFormContext()

  const [rolesPermission, setRolesPermission] = useState<RolePermission[] | []>([])
  const [isRegistering, setisRegistering] = useState(true)

  /**
   * Effect #1
   * - register permission to form state
   * */
  useEffect(() => {
    if (permissionKeys && register) {
      const registeredPermissions = registerPermissions(permissionKeys)
      register('permissions', {
        value: registeredPermissions,
      })
      setisRegistering(false)
    }
  }, [permissionKeys, register])

  /**
   * Effect #2
   * - set rolesPermission state value from getValues (form)
   * */
  useEffect(() => {
    if (!isRegistering) setRolesPermission(() => getValues()?.permissions || [])
  }, [getValues, isRegistering])

  if (isRegistering || isEmpty(permissionKeys) || isEmpty(rolesPermission)) return null

  return (
    <>
      <Grid container spacing={2} alignItems='center'>
        <Grid item xs={12} sm={4}>
          <TextInput
            source='name'
            label={`${ROLES_FIELDS}.name`}
            validate={[required()]}
            fullWidth
          />
        </Grid>
        <Grid item xs={12} sm={3}>
          <BooleanInput source='is_active' label={`${COMMON_FIELDS}.status.label`} />
        </Grid>
        <Grid item xs={12} sm={3}>
          <AllPermissionBooleanInput />
        </Grid>
      </Grid>
      <PermissionTable rolePermissionList={rolesPermission} permissionKeys={permissionKeys} />
    </>
  )
}

const RolesPermissionsCreate = (): JSX.Element => {
  return (
    <CreateBase
      title={`${RESOURCE_PREFIX}.title`}
      redirect='list'
      listAction={{
        hasList: true,
        hasBackButton: true,
      }}
    >
      <SimpleForm toolbar={<FormBottomToolbarWithPermission />}>
        <RolesPermissionsCreateFormBody />
      </SimpleForm>
    </CreateBase>
  )
}

export default RolesPermissionsCreate
